import { render, staticRenderFns } from "./SocialMediaInfo.vue?vue&type=template&id=319a1e45&"
import script from "./SocialMediaInfo.vue?vue&type=script&lang=js&"
export * from "./SocialMediaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports